import { dateInTimeZone } from '@/lib/zoned-date'

export type DiscoverySearchDefaults = {
  date: string
  time: string
}

const QUARTER_HOUR_MINUTES = 15
const QUARTER_HOUR_MS = QUARTER_HOUR_MINUTES * 60_000

export function createDiscoverySearchDefaults(now = new Date(), timeZone?: string): DiscoverySearchDefaults {
  const candidate = new Date((Math.floor(now.getTime() / QUARTER_HOUR_MS) + 1) * QUARTER_HOUR_MS)

  return {
    date: timeZone ? dateInTimeZone(candidate, timeZone) : toLocalDate(candidate),
    time: timeZone ? timeInTimeZone(candidate, timeZone) : toLocalTime(candidate),
  }
}

function timeInTimeZone(date: Date, timeZone: string) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(date)
      .filter((part) => part.type !== 'literal')
      .map((part) => [part.type, part.value]),
  )
  return `${parts.hour}:${parts.minute}`
}

function toLocalTime(date: Date) {
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

function toLocalDate(date: Date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
